import ListingDiscoveryContainer from "containers/v2/ListingDiscoveryContainer";
import ListingDisplayContainer from "containers/v2/ListingDisplayContainer";
import useTranslation from "next-translate/useTranslation";
import Head from "next/head";
import HeadSeoHelper from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";
import { useEffect } from "react";
import $ from "utils/selectors";
export default function ListingPagesHepler({
  initialListings,
  region,
  province,
  commune,
  quartier,
  title_complement,
  currentListing,
  annonceSlug,
  bienType,
  viewType,
  title,
  totalItems,
  page,
  url,
  isError,
  articleData,
}: {
  initialListings?: any[];
  region?: string;
  province?: string;
  commune?: string;
  quartier?: any;
  title_complement?: any;
  title?: string;
  currentListing?: any;
  annonceSlug?: string;

  bienType?: any;
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  totalItems: number;
  page: number;
  url?: string;
  isError?: boolean;
  articleData?: any;
}) {
  const { t, lang } = useTranslation("annonceAchat");

  useEffect(() => {
    if (window.innerWidth < 990) {
      $("#navbar__mobile__container").css({ display: "none" });
      $("body").css({ height: "auto" });
      $("body").css({ minHeight: "100%" });
    } else {
      $("body").css({ height: "100%" });
    }
  }, []);

  return (
    <>
      <div
        style={{
          overflow: "hidden",
          height: "100%",
        }}
      >
        <HeadSeoHelper
          t={t}
          lang={lang}
          quartier={quartier}
          title_complement={title_complement}
          {...{
            initialListings,
            region,
            province,
            commune,
            currentListing,
            annonceSlug,
            bienType,
            viewType,
            page,
            url,
          }}
        />
        {currentListing ? (
          <ListingDisplayContainer
            h1Type={currentListing ? true : false}
            viewType={viewType}
            annonceSlug={currentListing.slug}
            annoncesSimilaires={
              currentListing.similaires ? currentListing.similaires : []
            }
            annonce={currentListing}
            agence={currentListing.agence}
          />
        ) : (
          <></>
        )}

        <ListingDiscoveryContainer
          title={title}
          region={region ? region : null}
          province={province}
          commune={commune}
          viewType={viewType}
          initialListings={initialListings}
          RegionProvinceCommune={{ region, province, commune }}
          defaultBienType={bienType}
          totalItems={totalItems}
          h1Type={currentListing ? true : false}
          isError={isError}
          articleData={articleData}
        />
      </div>
    </>
  );
}
